import React from 'react';

const FRONT_ZONES = [
  { id: 'f-head', label: 'Kopf / Stirn', top: 0, left: 37, w: 26, h: 12, round: true },
  { id: 'f-neck', label: 'Hals (vorne)', top: 12, left: 42, w: 16, h: 4 },
  { id: 'f-shoulder-r', label: 'Schulter rechts', top: 16, left: 24, w: 18, h: 5 },
  { id: 'f-shoulder-l', label: 'Schulter links', top: 16, left: 58, w: 18, h: 5 },
  { id: 'f-chest-r', label: 'Brust rechts', top: 21, left: 30, w: 20, h: 12 },
  { id: 'f-chest-l', label: 'Brust links', top: 21, left: 50, w: 20, h: 12 },
  { id: 'f-upper-arm-r', label: 'Oberarm rechts', top: 18, left: 12, w: 12, h: 16 },
  { id: 'f-upper-arm-l', label: 'Oberarm links', top: 18, left: 76, w: 12, h: 16 },
  { id: 'f-upper-abdomen', label: 'Oberbauch', top: 33, left: 32, w: 36, h: 8 },
  { id: 'f-forearm-r', label: 'Unterarm rechts', top: 34, left: 6, w: 12, h: 16 },
  { id: 'f-forearm-l', label: 'Unterarm links', top: 34, left: 82, w: 12, h: 16 },
  { id: 'f-lower-abdomen', label: 'Unterbauch', top: 41, left: 34, w: 32, h: 7 },
  { id: 'f-pelvis-r', label: 'Leiste rechts', top: 48, left: 34, w: 16, h: 6 },
  { id: 'f-pelvis-l', label: 'Leiste links', top: 48, left: 50, w: 16, h: 6 },
  { id: 'f-hand-r', label: 'Hand rechts', top: 50, left: 4, w: 10, h: 8, round: true },
  { id: 'f-hand-l', label: 'Hand links', top: 50, left: 86, w: 10, h: 8, round: true },
  { id: 'f-thigh-r', label: 'Oberschenkel rechts', top: 54, left: 33, w: 16, h: 20 },
  { id: 'f-thigh-l', label: 'Oberschenkel links', top: 54, left: 51, w: 16, h: 20 },
  { id: 'f-knee-r', label: 'Knie rechts', top: 74, left: 33, w: 15, h: 5 },
  { id: 'f-knee-l', label: 'Knie links', top: 74, left: 52, w: 15, h: 5 },
  { id: 'f-shin-r', label: 'Unterschenkel rechts', top: 79, left: 34, w: 13, h: 16 },
  { id: 'f-shin-l', label: 'Unterschenkel links', top: 79, left: 53, w: 13, h: 16 },
  { id: 'f-foot-r', label: 'Fuß rechts', top: 95, left: 31, w: 14, h: 5, round: true },
  { id: 'f-foot-l', label: 'Fuß links', top: 95, left: 55, w: 14, h: 5, round: true },
];

const BACK_ZONES = [
  { id: 'b-head', label: 'Hinterkopf', top: 0, left: 37, w: 26, h: 12, round: true },
  { id: 'b-neck', label: 'Nacken', top: 12, left: 42, w: 16, h: 4 },
  { id: 'b-shoulder-l', label: 'Schulter links (hinten)', top: 16, left: 24, w: 18, h: 5 },
  { id: 'b-shoulder-r', label: 'Schulter rechts (hinten)', top: 16, left: 58, w: 18, h: 5 },
  { id: 'b-upper-back-l', label: 'Oberer Rücken links', top: 21, left: 30, w: 20, h: 12 },
  { id: 'b-upper-back-r', label: 'Oberer Rücken rechts', top: 21, left: 50, w: 20, h: 12 },
  { id: 'b-upper-arm-l', label: 'Oberarm links (hinten)', top: 18, left: 12, w: 12, h: 16 },
  { id: 'b-upper-arm-r', label: 'Oberarm rechts (hinten)', top: 18, left: 76, w: 12, h: 16 },
  { id: 'b-lower-back', label: 'Lendenwirbelsäule', top: 33, left: 32, w: 36, h: 8 },
  { id: 'b-forearm-l', label: 'Unterarm links (hinten)', top: 34, left: 6, w: 12, h: 16 },
  { id: 'b-forearm-r', label: 'Unterarm rechts (hinten)', top: 34, left: 82, w: 12, h: 16 },
  { id: 'b-sacral', label: 'Sakralbereich / Steißbein', top: 41, left: 38, w: 24, h: 5 },
  { id: 'b-hip-l', label: 'Trochanter links', top: 38, left: 22, w: 10, h: 10 },
  { id: 'b-hip-r', label: 'Trochanter rechts', top: 38, left: 68, w: 10, h: 10 },
  { id: 'b-buttock-l', label: 'Gesäß links', top: 46, left: 34, w: 16, h: 8, round: true },
  { id: 'b-buttock-r', label: 'Gesäß rechts', top: 46, left: 50, w: 16, h: 8, round: true },
  { id: 'b-hand-l', label: 'Handrücken links', top: 50, left: 4, w: 10, h: 8, round: true },
  { id: 'b-hand-r', label: 'Handrücken rechts', top: 50, left: 86, w: 10, h: 8, round: true },
  { id: 'b-thigh-l', label: 'Oberschenkel links (hinten)', top: 54, left: 33, w: 16, h: 20 },
  { id: 'b-thigh-r', label: 'Oberschenkel rechts (hinten)', top: 54, left: 51, w: 16, h: 20 },
  { id: 'b-knee-l', label: 'Kniekehle links', top: 74, left: 33, w: 15, h: 5 },
  { id: 'b-knee-r', label: 'Kniekehle rechts', top: 74, left: 52, w: 15, h: 5 },
  { id: 'b-calf-l', label: 'Wade links', top: 79, left: 34, w: 13, h: 16 },
  { id: 'b-calf-r', label: 'Wade rechts', top: 79, left: 53, w: 13, h: 16 },
  { id: 'b-heel-l', label: 'Ferse links', top: 95, left: 31, w: 14, h: 5, round: true },
  { id: 'b-heel-r', label: 'Ferse rechts', top: 95, left: 55, w: 14, h: 5, round: true },
];

function BodyFigure({ zones, selectedRegion, onSelect, label, flipRL }) {
  return (
    <div className="flex flex-col items-center">
      {/* RL labels */}
      <div className="flex justify-between w-full px-2 mb-1">
        <span className="w-5 h-5 rounded-full border border-teal-600 text-teal-700 text-[9px] font-bold flex items-center justify-center">
          {flipRL ? 'L' : 'R'}
        </span>
        <span className="w-5 h-5 rounded-full border border-teal-600 text-teal-700 text-[9px] font-bold flex items-center justify-center">
          {flipRL ? 'R' : 'L'}
        </span>
      </div>
      {/* Body container */}
      <div className="relative w-full" style={{ paddingBottom: '200%' }}>
        <div className="absolute inset-0">
          {zones.map(z => {
            const isSelected = selectedRegion === z.id;
            return (
              <button
                type="button"
                key={z.id}
                onClick={() => onSelect(z.id, z.label)}
                title={z.label}
                data-testid={`body-region-${z.id}`}
                className={`absolute transition-all duration-150 border-[0.5px] border-white/60 ${
                  z.round ? 'rounded-full' : 'rounded-[3px]'
                } ${
                  isSelected
                    ? 'bg-teal-600 ring-2 ring-teal-400 ring-offset-1 z-10'
                    : 'bg-slate-400 hover:bg-slate-500 active:bg-teal-500'
                }`}
                style={{
                  top: `${z.top}%`,
                  left: `${z.left}%`,
                  width: `${z.w}%`,
                  height: `${z.h}%`,
                }}
              />
            );
          })}
        </div>
      </div>
      <p className="text-xs text-slate-500 mt-1 font-medium">{label}</p>
    </div>
  );
}

export default function BodyMap({ selectedRegion, onSelect }) {
  const allZones = [...FRONT_ZONES, ...BACK_ZONES];

  return (
    <div className="space-y-3" data-testid="body-map">
      <div className="grid grid-cols-2 gap-6 max-w-sm mx-auto">
        <BodyFigure
          zones={FRONT_ZONES}
          selectedRegion={selectedRegion}
          onSelect={onSelect}
          label="Vorderseite"
          flipRL={false}
        />
        <BodyFigure
          zones={BACK_ZONES}
          selectedRegion={selectedRegion}
          onSelect={onSelect}
          label="Rückseite"
          flipRL={true}
        />
      </div>
      {selectedRegion && (
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-teal-50 text-teal-700 rounded-lg text-sm font-medium border border-teal-200">
            <span className="w-2 h-2 rounded-full bg-teal-600" />
            {allZones.find(r => r.id === selectedRegion)?.label || selectedRegion}
          </span>
        </div>
      )}
    </div>
  );
}
